<template>
  <div class="impressum">
    <section class="lb-section">
      <div class="lb-container lb-container--narrow">
        <SectionLabel text="Rechtliches" />
        <h1>Impressum</h1>

        <h2>Angaben gemäß § 5 TMG</h2>
        <p>
          Kilian Link<br />
          LinkBeratung<br />
          Lohstr. 56<br />
          81543 München-Untergiesing<br />
          Deutschland
        </p>

        <h2>Kontakt</h2>
        <p>
          E-Mail: <a href="mailto:kontakt@linkberatung.de">kontakt@linkberatung.de</a>
        </p>

        <h2>Aufsichtsbehörde</h2>
        <p>
          Industrie- und Handelskammer für München und Oberbayern<br />
          Balanstraße 55–59, 81541 München<br />
          <a href="https://www.muenchen.ihk.de" target="_blank" rel="noopener">www.muenchen.ihk.de</a>
        </p>

        <h2>Berufsbezeichnung</h2>
        <p>
          Versicherungsvermittler gemäß § 34d Abs. 1 GewO<br />
          (Bundesrepublik Deutschland)
        </p>

        <h2>Registereintragung</h2>
        <p>
          Eintragung im Vermittlerregister<br />
          Registernummer: § 34d D-35B4-VQTG7-49<br />
          Registerbehörde: DIHK – Deutscher Industrie- und Handelskammertag e. V.<br />
          Breite Straße 29, 10178 Berlin<br />
          <a href="https://www.vermittlerregister.info" target="_blank" rel="noopener">www.vermittlerregister.info</a>
        </p>

        <h2>Umsatzsteuer-ID</h2>
        <p>
          Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:<br />
          DE 231 682 814
        </p>

        <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
        <p>
          Kilian Link (Anschrift wie oben)
        </p>

        <h2>EU-Streitschlichtung</h2>
        <p>
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung
          (OS) bereit:
          <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener">https://ec.europa.eu/consumers/odr</a>.<br />
          Unsere E-Mail-Adresse finden Sie oben im Impressum.
        </p>

        <h2>Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
        <p>
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor
          einer Verbraucherschlichtungsstelle teilzunehmen.
        </p>

        <h2>Haftung für Inhalte</h2>
        <p>
          Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf
          diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis
          10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte
          oder gespeicherte fremde Informationen zu überwachen oder nach Umständen
          zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
        </p>

        <h2>Datenschutz</h2>
        <p>
          Die Nutzung unserer Webseite ist in der Regel ohne Angabe personenbezogener
          Daten möglich. Soweit auf unseren Seiten personenbezogene Daten erhoben
          werden (etwa über das Kontaktformular), erfolgt dies stets auf freiwilliger
          Basis. Diese Daten werden ohne Ihre ausdrückliche Zustimmung nicht an
          Dritte weitergegeben.
        </p>

      </div>
    </section>
  </div>
</template>

<script setup>
import { onMounted, inject } from "vue";
import SectionLabel from "@/components/ui/SectionLabel.vue";

const updateDocumentHead = inject("updateDocumentHead", null);

onMounted(() => {
  if (updateDocumentHead) {
    updateDocumentHead(
      "Impressum — LinkBeratung | Kilian Link",
      "Impressum und rechtliche Angaben der LinkBeratung von Kilian Link, Versicherungsvermittler gemäß § 34d Abs. 1 GewO."
    );
  }
});
</script>

<style scoped>
.impressum h1 {
  margin: 16px 0 28px;
  font-size: clamp(38px, 5vw, 60px);
}

.impressum h2 {
  font-size: clamp(22px, 2.4vw, 28px);
  margin-top: 36px;
  margin-bottom: 10px;
}

.impressum p {
  font-size: 17px;
  color: var(--lb-ink-soft);
}

.impressum a {
  color: var(--lb-accent);
}

.impressum__hint {
  margin-top: 48px;
  padding: 18px 22px;
  background: var(--lb-cream);
  border-radius: 12px;
  border-left: 4px solid var(--lb-cta);
  color: var(--lb-ink) !important;
  font-size: 15px !important;
}
</style>
